import React, { useEffect } from 'react';

import { styled } from '@mui/material/styles';
import { Box, Grid, Divider } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getIsGuess } from 'common/utils/helpers/session';

import fondoLogin1 from 'resources/fondoLogin1.png';
import fondoLoginCreateAccount from 'resources/fondoLoginCreateAccount.jpg';
import logotipo from 'resources/logotipo.svg';

import { sendResetPasswordEmail } from './actions';
import { ForgotPasswordForm } from './components';
import * as selectors from './selectors';

const ResendLink = styled('a')`
    color: #0047ba;
    &:hover {
        color: #0047ba;
        font-weight: bold;
        text-decoration: none;
    }
`;

const StyledSpan = styled('span')`
    color: #838bab;
    @media all and (max-width: 1500px) {
        font-size: 15px !important;
        font-weight: bold;
        line-height: 0.1;
    }
`;

const StyledRow = styled(Grid)`
    background: #fff url(${fondoLogin1});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
`;

const StyledCol = styled(Grid)`
    background: #fff url(${fondoLoginCreateAccount});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`;

const Container = ({
    errors,
    initialValues,
    isLoadingSession,
    redirect,
    showForgotPasswordForm,
    sendResetPasswordEmail,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (!getIsGuess()) {
            redirect('/');
        }
    }, []);

    const handleSubmit = (values) => {
        sendResetPasswordEmail(values);
    };

    return (
        <>
            {showForgotPasswordForm ? (
                <Grid container spacing={0} sx={{ height: '100%' }}>
                    <Grid size="grow" sx={{ height: '100%' }}>
                        <StyledRow
                            container
                            spacing={0}
                            alignItems="center"
                            justifyContent="center"
                            sx={{ height: '100%', p: 2 }}
                        >
                            <Grid
                                size={{ md: 14, xs: 'grow' }}
                                sx={{ textAlign: 'center' }}
                            >
                                <Box sx={{ mb: 2 }}>
                                    <img src={logotipo} width="238" />
                                </Box>

                                <h1>{t('Recover password')}</h1>

                                <Divider sx={{ mb: 2 }} />

                                <Box sx={{ mb: 2 }}>
                                    {t(
                                        'Enter your email to reset your password',
                                    )}
                                </Box>

                                <ForgotPasswordForm
                                    initialValues={initialValues}
                                    onSubmit={handleSubmit}
                                    isLoadingSession={isLoadingSession}
                                    errors={errors}
                                />
                            </Grid>
                        </StyledRow>
                    </Grid>

                    <StyledCol
                        size="grow"
                        sx={{ display: { xs: 'none', lg: 'flex' } }}
                    />
                </Grid>
            ) : (
                <Grid
                    container
                    sx={{
                        alignItems: 'center',
                        height: '100%',
                        justifyContent: 'center',
                    }}
                >
                    <Grid sx={{ textAlign: 'center', p: 2 }}>
                        <p>
                            <img src={logotipo} width="300" />
                        </p>

                        <br />

                        <h1>
                            <StyledSpan>
                                {t(
                                    'We send you a message to the registered email to reset your password',
                                )}
                            </StyledSpan>
                        </h1>

                        <p>
                            {t("Didn't the mail reach you?")}{' '}
                            <ResendLink href="/reset-password">
                                {t('Resend')}
                            </ResendLink>
                        </p>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    showForgotPasswordForm: selectors.getShowForgotPasswordForm,
    initialValues: selectors.getInitialValues,
    isLoadingSession: selectors.getIsLoadingSession,
    errors: selectors.getErrorsLogin,
});

const mapDispatchToProps = (dispatch) => {
    return {
        sendResetPasswordEmail: (data) =>
            dispatch(sendResetPasswordEmail(data)),
        redirect: (link) => dispatch(push(link)),
    };
};

Container.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    redirect: PropTypes.func,
    sendResetPasswordEmail: PropTypes.func,
    showForgotPasswordForm: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
